import styled from 'styled-components'

export const DetailsIconContainer = styled.div`
  background: ${props => props.color};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 1rem;
  margin-bottom: 1.5rem;

  @media only screen and (max-width: 700px) {
    margin-left: auto;
    margin-right: auto;
  }
`
